import { CustomBreadcrumb } from 'components/CustomBreadcrumb';
import { PageHeader } from 'components/professor_area/PageHeader';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { Space, Tag } from 'antd';
import { TabList } from './components/TabList';
import { TeamOutlined } from '@ant-design/icons';
import { useShow } from '@refinedev/core';
import type { IProfessorAreaClassroom } from 'interfaces/professor_area_classrooms';

export const ClassroomShow = () => {
  const { queryResult } = useShow<IProfessorAreaClassroom>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <ShowLayout
      isLoading={isLoading}
      breadcrumb={
        <CustomBreadcrumb
          label="Área do professor"
          backButton
          items={[
            {
              label: 'Turmas',
              path: '/professor_area/classrooms'
            },
            {
              label: 'Visualizar'
            }
          ]}
        />
      }
    >
      {record && (
        <>
          <PageHeader
            title={record.discipline_name}
            icon={TeamOutlined}
            meta={
              <Space className="!gap-0">
                <Tag>{record?.code}</Tag>
                <Tag>
                  {record?.academic_year}.{record?.academic_period}
                </Tag>
              </Space>
            }
          />
          <TabList record={record} />
        </>
      )}
    </ShowLayout>
  );
};
